import React, { Component } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';

function BasicMap(props) {
  return (
    <GoogleMap
      ref={props.onMapMounted}
      mapContainerStyle={{ width: '100%', height: '100%' }}
      option={{ gestureHandling: 'greedy' }}
      zoom={props.zoom}
      center={props.center}
    >
      <Marker
        position={props.center}
        draggable={props.allowDrag}
        onDragEnd={(event) => {
          const { latLng } = event;
          const lat = latLng.lat();
          const lng = latLng.lng();
          return props.handlePositionChange(lat, lng);
        }}
      />
    </GoogleMap>
  );
}

const DEFAULT_ZOOM_LEVEL = 15;
const DEFAULT_CENTER = { lat: 36, lng: -100 };

class SmallMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoom: DEFAULT_ZOOM_LEVEL,
    };
  }

  render() {
    return (
      <div id="map" style={{ height: '300px', width: '100%' }}>
        <BasicMap
          containerElement={<div style={{ height: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          zoom={this.state.zoom}
          center={this.props.center || DEFAULT_CENTER}
          handlePositionChange={this.props.handlePositionChange}
          allowDrag={this.props.allowDrag || false}
        />
      </div>
    );
  }
}

export default SmallMap;
